var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDsa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#4659CA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_1266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.903 17.9064C31.6382 16.7627 29.6759 16.8605 28.5285 18.1212C28.3134 18.3576 28.1474 18.6193 28.0199 18.8966L24.0662 18.2901C24.0092 17.3815 23.6153 16.4843 22.8749 15.8147C21.5705 14.6353 19.6552 14.56 18.3434 15.5476L16.5384 13.9154C17.0476 12.9442 16.8644 11.7204 16.0133 10.9508C15.0041 10.0382 13.4386 10.1117 12.5207 11.1203C11.6028 12.1289 11.6791 13.6918 12.691 14.6068C13.5394 15.374 14.7844 15.4416 15.702 14.8398L17.507 16.4719C17.0287 17.2508 16.9005 18.1835 17.1094 19.057L13.7662 20.3767C13.6245 20.1576 13.4558 19.9524 13.2582 19.7737C11.9934 18.63 10.0284 18.7253 8.88108 19.9861C7.73371 21.2469 7.82938 23.2055 9.09419 24.3492C10.359 25.4929 12.3239 25.3976 13.4713 24.1368C14.1358 23.4066 14.371 22.4462 14.2159 21.5399L17.5965 20.2109C17.7655 20.4738 17.9715 20.7224 18.214 20.9416C18.7963 21.4682 19.5038 21.7728 20.2238 21.8684L20.3553 24.458C19.951 24.5855 19.5666 24.8126 19.2631 25.1462C18.3452 26.1548 18.4215 27.7177 19.4334 28.6326C20.4426 29.5452 22.0131 29.4715 22.931 28.4629C23.8465 27.4569 23.7699 25.889 22.7607 24.9764C22.3681 24.6214 21.89 24.4237 21.401 24.3645L21.2679 21.8453C21.6026 21.7889 21.9275 21.6853 22.2372 21.5297C22.5963 21.3516 22.9291 21.1019 23.2136 20.7894C23.553 20.4164 23.7837 19.9834 23.9227 19.5298L27.7419 20.1152C27.7162 20.9826 28.0486 21.8577 28.7416 22.4843C30.0064 23.6281 31.9714 23.5327 33.1187 22.2719C34.2661 21.0112 34.1678 19.0501 32.903 17.9064Z",
    fill: "#F8FAFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_1266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.7363,
    height: 22.7293,
    fill: "white",
    transform: "matrix(0.741725 0.670704 -0.673062 0.739586 19 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsa);
export default __webpack_public_path__ + "static/media/dsa.9d83a4a88ff347e2f7e74d06656b9c13.svg";
export { ForwardRef as ReactComponent };